import { useCallback, useEffect, useRef } from 'react';

export const useOutsideClick = (callback: () => void) => {
	const ref = useRef<HTMLElement | null>(null);

	const handleClick = useCallback(
		(event: MouseEvent) => {
			if (ref.current && !ref.current.contains(event.target as Node)) {
				callback();
			}
		},
		[ref]
	);

	useEffect(() => {
		document.addEventListener('click', handleClick, true);

		return () => {
			document.removeEventListener('click', () => {}, true);
		};
	}, [ref]);

	return ref;
};
